// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Inbox-textTruncate-bMdnY {
 	overflow: hidden;
 	white-space: nowrap;
 	text-overflow: ellipsis;
 	max-width: 95px;
 }

 .Inbox-threadName-saxyc {
 	font-size: 14px;
 	padding-top: 5px
 }

 .Inbox-threadName-saxyc div {
 	text-overflow: ellipsis;
 	overflow: hidden;
 }

 .Inbox-threadBody-FxSUO {
 	padding-top: 5px;
 }

 .Inbox-textMuted-rAjzY {
 	color: var(--modalText-color);
 	cursor: pointer;
 	font-size: 14px;
 }

 .Inbox-threadLabel-vT1Hp {
 	padding-top: 5px;
 }

 .Inbox-listUnstyled-ttYoI {
 	padding-left: 0;
 	list-style: none;
 	line-height: 0.8;
 }

 .Inbox-space1-SRDE6 {
 	margin-bottom: 6px;
 }

 .Inbox-spaceTop2-rLXS7 {
 	margin-top: 12px;
 }

 .Inbox-threadAction-uwULJ {
 	display: inline-block;
 }

 .Inbox-iconText-o_H6V {
 	font-size: 14px;
 	display: none;
 }

 .Inbox-PanelBody-VUVfw:hover .Inbox-iconText-o_H6V {
 	display: block;
 }

 /* .showLg{
  display:none !important;
} */

 .Inbox-labelText-bXRqI {
 	font-size: 16px;
 }

 .Inbox-tabs-tdkQz {
 	margin-bottom: 0;
 	padding: 0;
 	list-style: none;
 	display: table;
 	table-layout: fixed;
 	width: 100%;
 	font-size: inherit;
 }

 @media screen and (min-width: 1128px) {
 	.Inbox-showLg-UoU6b {
 		display: block !important;
 	}
 }

 @media screen and (max-width: 768px) {
 	.Inbox-progressContainerResponsive-cVnOU {
 		padding: 0;
 		margin: 0;
 		overflow: hidden;
 	}

 	.Inbox-tabs-tdkQz {
 		width: 100%;
 		margin-bottom: 15px;
 		border-width: 1px;
 		border-bottom: 1px solid var(--primary-border);
 	}

 	.Inbox-inboxNav-Hiqq4 {
 		padding: 10px 20px 13px;
 	}

 	.Inbox-h4-R1AxM {
 		font-size: 17px;
 	}

 	.Inbox-formControlSelect-H4x2F {
 		font-size: 15px;
 		width: 100%
 	}

 	.Inbox-threadAuthor-I_YZt {
 		position: static;
 	}

 	.Inbox-threadAvatar-c5t4h {
 		float: left;
 		padding-right: 0;
 	}

 	.Inbox-threadName-saxyc {
 		font-size: 16px;
 		margin-top: -5px;
 		padding-top: 0;
 		padding-left: 32px;
 		position: static;
 	}

 	.Inbox-threadDate-T96Rg {
 		font-weight: normal;
 		font-size: 12px;
 		position: absolute;
 		top: 12px;
 		right: 0px;
 		color: var(--modalText-color);
 	}

 	.Inbox-threadLink-adVLO {
 		position: absolute;
 		top: 0;
 		left: 0;
 		width: 100%;
 		height: 100%;
 		z-index: 1;
 	}

 	.Inbox-threadBody-FxSUO {
 		position: static;
 	}

 	.Inbox-threadSubject-CO094 {
 		position: absolute;
 		top: 36px;
 		left: 61.5px;
 		width: calc(100% - 105px);
 		padding-left: 24px;
 		white-space: nowrap;
 		overflow: hidden;
 		text-overflow: ellipsis;
 	}

 	.Inbox-threadSubject-CO094::before {
 		left: 0;
 	}

 	.Inbox-PanelBody-VUVfw:hover .Inbox-iconText-o_H6V {
 		display: none;
 	}

 	.Inbox-threadLabel-vT1Hp {
 		position: absolute;
 		top: 51px;
 		left: 70px;
 		padding-top: 10px;
 	}
 }

 .Inbox-panelHeader-lOnVK {
 	border-radius: 0;
 	width: 100%;
 	display: block;
 	color: var(--common-text-color);
 	font-size: 15px;
 	padding-bottom: 0px;
 	border-bottom: 1px solid var(--primary-border);
 	border: none;
 	-webkit-box-shadow: none;
 	        box-shadow: none;
 	background: transparent;
 }

 .Inbox-PanelBody-VUVfw {
 	margin: 0;
 	padding: 15px 0px;
 	position: relative;
 	border-bottom: none;
 }

 .Inbox-formControlSelect-H4x2F {
 	height: 40px;
 	border-radius: 2px;
 	margin-bottom: 8px;
 	font-size: 16px;
 	padding: 8px 10px;
 	width: 100%;
 	border: 1px solid var(--primary-border);
 	background-color: var(--primary-white-bg);
 	color: var(--common-text-color);
 	display: inline-block;
 	overflow: hidden;
 	-webkit-appearance: none;
 	   -moz-appearance: none;
 	        appearance: none;
 }

 .Inbox-textRight-dXhQ7 {
 	float: right;
 }

 .Inbox-listLayout-NHvv6 {
 	margin-bottom: 0;
 	padding-left: 0;
 	list-style: none;
 	color: var(--common-text-color);
 }

 /*************************verification Styles end******************************************/

 .Inbox-profileAvatarSection-kno77 {
 	position: relative;
 	margin: 0 auto;
 }

 .Inbox-profileAvatarLink-bYMgu {
 	-webkit-backface-visibility: hidden;
 	        backface-visibility: hidden;
 	position: relative;
 	display: inline-block;
 	overflow: hidden;
 	background-color: var(--common-gray-bg-color);
 	border-radius: 50%;
 	border: 2px solid var(--primary-white-bg);
 	position: relative;
 	z-index: 4;
 }

 .Inbox-iconColor-SzXvr {
 	color: var(--common-link-color);
 }

 .Inbox-displayTable-zWY4N {
 	display: table;
 	width: 100%;
 	background: var(--primary-white-bg);
 	border-radius: 30px;
 }

 .Inbox-displayTableRow-cOHaD {
 	width: 100%;
 	display: table-row;
 }

 .Inbox-displayTableCell-uZNaj {
 	display: table-cell;
 	vertical-align: middle;
 }

 .Inbox-IconWidth-wEorb {
 	width: 10%;
 }

 .Inbox-rightBg-s2_qR {
 	background: var(--primary-white-bg);
 	padding: 0px 15px;
 	position: relative;
 	width: 90%;
 }

 .Inbox-timeWidth-Nvn6f {
 	width: 20%;
 }

 .Inbox-addressWidth-AZExJ {
 	width: 65%;
 }

 .Inbox-btnWidth-uP4KD {
 	width: 15%;
 }

 .Inbox-floatLeft-PdPg4 {
 	float: left;
 	margin: 0 3px 0 0;
 }

 .Inbox-inboxBg-fxxGP {
 	padding: 10px 10px 5px 10px;
 	border: 1px solid var(--primary-border);
 }

 @media screen and (max-width: 640px) {
 	.Inbox-xsHidden-iyI6J {
 		display: none;
 	}
 }

 @media screen and (max-width: 767px) {
 	.Inbox-displayBlock-dCrC6 {
 		display: block;
 		width: 100%;
 		margin-bottom: 6px;
 	}

 	.Inbox-rightBg-s2_qR {
 		padding: 0px 15px;
 	}

 	.Inbox-textTruncate-bMdnY {
 		max-width: 70%;
 	}

 	.Inbox-inboxBg-fxxGP {
 		padding: 10px;
 	}

 	.Inbox-IconWidth-wEorb {
 		vertical-align: top !important;
 	}
 }

 .Inbox-progressContainerResponsive-cVnOU {
 	margin-left: auto;
 	margin-right: auto;
 	max-width: 1080px;
 	width: 100%;
 }

 .Inbox-h4-R1AxM {
 	font-size: 18px;
 	font-weight: bold;
 	line-height: 1.1;
 }

 .Inbox-tabItem-mHxfL {
 	display: block;
 	padding: 14px 15px;
 	position: relative;
 	text-align: center;
 	color: var(--modalText-color);
 	cursor: pointer;
 	border-bottom: 5px solid transparent;
 }

 .Inbox-tabItem-mHxfL:hover {
 	text-decoration: none;
 	color: var(--common-text-color);
 }

 .Inbox-active-aw0At .Inbox-tabItem-mHxfL {
 	color: var(--common-text-color);
 	border-color: #00a699;
 	text-decoration: none;
 }`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Inbox.css"],"names":[],"mappings":"CAAC;EACC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;CAChB;;CAEA;EACC,eAAe;EACf;CACD;;CAEA;EACC,uBAAuB;EACvB,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,6BAA6B;EAC7B,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,aAAa;CACd;;CAEA;EACC,cAAc;CACf;;CAEA;;GAEE;;CAEF;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC;GACC,yBAAyB;EAC1B;CACD;;CAEA;EACC;GACC,UAAU;GACV,SAAS;GACT,gBAAgB;EACjB;;EAEA;GACC,WAAW;GACX,mBAAmB;GACnB,iBAAiB;GACjB,8CAA8C;EAC/C;;EAEA;GACC,uBAAuB;EACxB;;EAEA;GACC,eAAe;EAChB;;EAEA;GACC,eAAe;GACf;EACD;;EAEA;GACC,gBAAgB;EACjB;;EAEA;GACC,WAAW;GACX,gBAAgB;EACjB;;EAEA;GACC,eAAe;GACf,gBAAgB;GAChB,cAAc;GACd,kBAAkB;GAClB,gBAAgB;EACjB;;EAEA;GACC,mBAAmB;GACnB,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,UAAU;GACV,6BAA6B;EAC9B;;EAEA;GACC,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,WAAW;GACX,YAAY;GACZ,UAAU;EACX;;EAEA;GACC,gBAAgB;EACjB;;EAEA;GACC,kBAAkB;GAClB,SAAS;GACT,YAAY;GACZ,yBAAyB;GACzB,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;EACxB;;EAEA;GACC,OAAO;EACR;;EAEA;GACC,aAAa;EACd;;EAEA;GACC,kBAAkB;GAClB,SAAS;GACT,UAAU;GACV,iBAAiB;EAClB;CACD;;CAEA;EACC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,wBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,uCAAuC;EACvC,yCAAyC;EACzC,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;CACjB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;CAChC;;CAEA,2FAA2F;;CAE3F;EACC,kBAAkB;EAClB,cAAc;CACf;;CAEA;EACC,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;CACX;;CAEA;EACC,+BAA+B;CAChC;;CAEA;EACC,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EACX,iBAAiB;CAClB;;CAEA;EACC,2BAA2B;EAC3B,uCAAuC;CACxC;;CAEA;EACC;GACC,aAAa;EACd;CACD;;CAEA;EACC;GACC,cAAc;GACd,WAAW;GACX,kBAAkB;EACnB;;EAEA;GACC,iBAAiB;EAClB;;EAEA;GACC,cAAc;EACf;;EAEA;GACC,aAAa;EACd;;EAEA;GACC,8BAA8B;EAC/B;CACD;;CAEA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;CACrC;;CAEA;EACC,qBAAqB;EACrB,+BAA+B;CAChC;;CAEA;EACC,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;CACtB","sourcesContent":[" .textTruncate {\n \toverflow: hidden;\n \twhite-space: nowrap;\n \ttext-overflow: ellipsis;\n \tmax-width: 95px;\n }\n\n .threadName {\n \tfont-size: 14px;\n \tpadding-top: 5px\n }\n\n .threadName div {\n \ttext-overflow: ellipsis;\n \toverflow: hidden;\n }\n\n .threadBody {\n \tpadding-top: 5px;\n }\n\n .textMuted {\n \tcolor: var(--modalText-color);\n \tcursor: pointer;\n \tfont-size: 14px;\n }\n\n .threadLabel {\n \tpadding-top: 5px;\n }\n\n .listUnstyled {\n \tpadding-left: 0;\n \tlist-style: none;\n \tline-height: 0.8;\n }\n\n .space1 {\n \tmargin-bottom: 6px;\n }\n\n .spaceTop2 {\n \tmargin-top: 12px;\n }\n\n .threadAction {\n \tdisplay: inline-block;\n }\n\n .iconText {\n \tfont-size: 14px;\n \tdisplay: none;\n }\n\n .PanelBody:hover .iconText {\n \tdisplay: block;\n }\n\n /* .showLg{\n  display:none !important;\n} */\n\n .labelText {\n \tfont-size: 16px;\n }\n\n .tabs {\n \tmargin-bottom: 0;\n \tpadding: 0;\n \tlist-style: none;\n \tdisplay: table;\n \ttable-layout: fixed;\n \twidth: 100%;\n \tfont-size: inherit;\n }\n\n @media screen and (min-width: 1128px) {\n \t.showLg {\n \t\tdisplay: block !important;\n \t}\n }\n\n @media screen and (max-width: 768px) {\n \t.progressContainerResponsive {\n \t\tpadding: 0;\n \t\tmargin: 0;\n \t\toverflow: hidden;\n \t}\n\n \t.tabs {\n \t\twidth: 100%;\n \t\tmargin-bottom: 15px;\n \t\tborder-width: 1px;\n \t\tborder-bottom: 1px solid var(--primary-border);\n \t}\n\n \t.inboxNav {\n \t\tpadding: 10px 20px 13px;\n \t}\n\n \t.h4 {\n \t\tfont-size: 17px;\n \t}\n\n \t.formControlSelect {\n \t\tfont-size: 15px;\n \t\twidth: 100%\n \t}\n\n \t.threadAuthor {\n \t\tposition: static;\n \t}\n\n \t.threadAvatar {\n \t\tfloat: left;\n \t\tpadding-right: 0;\n \t}\n\n \t.threadName {\n \t\tfont-size: 16px;\n \t\tmargin-top: -5px;\n \t\tpadding-top: 0;\n \t\tpadding-left: 32px;\n \t\tposition: static;\n \t}\n\n \t.threadDate {\n \t\tfont-weight: normal;\n \t\tfont-size: 12px;\n \t\tposition: absolute;\n \t\ttop: 12px;\n \t\tright: 0px;\n \t\tcolor: var(--modalText-color);\n \t}\n\n \t.threadLink {\n \t\tposition: absolute;\n \t\ttop: 0;\n \t\tleft: 0;\n \t\twidth: 100%;\n \t\theight: 100%;\n \t\tz-index: 1;\n \t}\n\n \t.threadBody {\n \t\tposition: static;\n \t}\n\n \t.threadSubject {\n \t\tposition: absolute;\n \t\ttop: 36px;\n \t\tleft: 61.5px;\n \t\twidth: calc(100% - 105px);\n \t\tpadding-left: 24px;\n \t\twhite-space: nowrap;\n \t\toverflow: hidden;\n \t\ttext-overflow: ellipsis;\n \t}\n\n \t.threadSubject::before {\n \t\tleft: 0;\n \t}\n\n \t.PanelBody:hover .iconText {\n \t\tdisplay: none;\n \t}\n\n \t.threadLabel {\n \t\tposition: absolute;\n \t\ttop: 51px;\n \t\tleft: 70px;\n \t\tpadding-top: 10px;\n \t}\n }\n\n .panelHeader {\n \tborder-radius: 0;\n \twidth: 100%;\n \tdisplay: block;\n \tcolor: var(--common-text-color);\n \tfont-size: 15px;\n \tpadding-bottom: 0px;\n \tborder-bottom: 1px solid var(--primary-border);\n \tborder: none;\n \tbox-shadow: none;\n \tbackground: transparent;\n }\n\n .PanelBody {\n \tmargin: 0;\n \tpadding: 15px 0px;\n \tposition: relative;\n \tborder-bottom: none;\n }\n\n .formControlSelect {\n \theight: 40px;\n \tborder-radius: 2px;\n \tmargin-bottom: 8px;\n \tfont-size: 16px;\n \tpadding: 8px 10px;\n \twidth: 100%;\n \tborder: 1px solid var(--primary-border);\n \tbackground-color: var(--primary-white-bg);\n \tcolor: var(--common-text-color);\n \tdisplay: inline-block;\n \toverflow: hidden;\n \tappearance: none;\n }\n\n .textRight {\n \tfloat: right;\n }\n\n .listLayout {\n \tmargin-bottom: 0;\n \tpadding-left: 0;\n \tlist-style: none;\n \tcolor: var(--common-text-color);\n }\n\n /*************************verification Styles end******************************************/\n\n .profileAvatarSection {\n \tposition: relative;\n \tmargin: 0 auto;\n }\n\n .profileAvatarLink {\n \tbackface-visibility: hidden;\n \tposition: relative;\n \tdisplay: inline-block;\n \toverflow: hidden;\n \tbackground-color: var(--common-gray-bg-color);\n \tborder-radius: 50%;\n \tborder: 2px solid var(--primary-white-bg);\n \tposition: relative;\n \tz-index: 4;\n }\n\n .iconColor {\n \tcolor: var(--common-link-color);\n }\n\n .displayTable {\n \tdisplay: table;\n \twidth: 100%;\n \tbackground: var(--primary-white-bg);\n \tborder-radius: 30px;\n }\n\n .displayTableRow {\n \twidth: 100%;\n \tdisplay: table-row;\n }\n\n .displayTableCell {\n \tdisplay: table-cell;\n \tvertical-align: middle;\n }\n\n .IconWidth {\n \twidth: 10%;\n }\n\n .rightBg {\n \tbackground: var(--primary-white-bg);\n \tpadding: 0px 15px;\n \tposition: relative;\n \twidth: 90%;\n }\n\n .timeWidth {\n \twidth: 20%;\n }\n\n .addressWidth {\n \twidth: 65%;\n }\n\n .btnWidth {\n \twidth: 15%;\n }\n\n .floatLeft {\n \tfloat: left;\n \tmargin: 0 3px 0 0;\n }\n\n .inboxBg {\n \tpadding: 10px 10px 5px 10px;\n \tborder: 1px solid var(--primary-border);\n }\n\n @media screen and (max-width: 640px) {\n \t.xsHidden {\n \t\tdisplay: none;\n \t}\n }\n\n @media screen and (max-width: 767px) {\n \t.displayBlock {\n \t\tdisplay: block;\n \t\twidth: 100%;\n \t\tmargin-bottom: 6px;\n \t}\n\n \t.rightBg {\n \t\tpadding: 0px 15px;\n \t}\n\n \t.textTruncate {\n \t\tmax-width: 70%;\n \t}\n\n \t.inboxBg {\n \t\tpadding: 10px;\n \t}\n\n \t.IconWidth {\n \t\tvertical-align: top !important;\n \t}\n }\n\n .progressContainerResponsive {\n \tmargin-left: auto;\n \tmargin-right: auto;\n \tmax-width: 1080px;\n \twidth: 100%;\n }\n\n .h4 {\n \tfont-size: 18px;\n \tfont-weight: bold;\n \tline-height: 1.1;\n }\n\n .tabItem {\n \tdisplay: block;\n \tpadding: 14px 15px;\n \tposition: relative;\n \ttext-align: center;\n \tcolor: var(--modalText-color);\n \tcursor: pointer;\n \tborder-bottom: 5px solid transparent;\n }\n\n .tabItem:hover {\n \ttext-decoration: none;\n \tcolor: var(--common-text-color);\n }\n\n .active .tabItem {\n \tcolor: var(--common-text-color);\n \tborder-color: #00a699;\n \ttext-decoration: none;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textTruncate": `Inbox-textTruncate-bMdnY`,
	"threadName": `Inbox-threadName-saxyc`,
	"threadBody": `Inbox-threadBody-FxSUO`,
	"textMuted": `Inbox-textMuted-rAjzY`,
	"threadLabel": `Inbox-threadLabel-vT1Hp`,
	"listUnstyled": `Inbox-listUnstyled-ttYoI`,
	"space1": `Inbox-space1-SRDE6`,
	"spaceTop2": `Inbox-spaceTop2-rLXS7`,
	"threadAction": `Inbox-threadAction-uwULJ`,
	"iconText": `Inbox-iconText-o_H6V`,
	"PanelBody": `Inbox-PanelBody-VUVfw`,
	"labelText": `Inbox-labelText-bXRqI`,
	"tabs": `Inbox-tabs-tdkQz`,
	"showLg": `Inbox-showLg-UoU6b`,
	"progressContainerResponsive": `Inbox-progressContainerResponsive-cVnOU`,
	"inboxNav": `Inbox-inboxNav-Hiqq4`,
	"h4": `Inbox-h4-R1AxM`,
	"formControlSelect": `Inbox-formControlSelect-H4x2F`,
	"threadAuthor": `Inbox-threadAuthor-I_YZt`,
	"threadAvatar": `Inbox-threadAvatar-c5t4h`,
	"threadDate": `Inbox-threadDate-T96Rg`,
	"threadLink": `Inbox-threadLink-adVLO`,
	"threadSubject": `Inbox-threadSubject-CO094`,
	"panelHeader": `Inbox-panelHeader-lOnVK`,
	"textRight": `Inbox-textRight-dXhQ7`,
	"listLayout": `Inbox-listLayout-NHvv6`,
	"profileAvatarSection": `Inbox-profileAvatarSection-kno77`,
	"profileAvatarLink": `Inbox-profileAvatarLink-bYMgu`,
	"iconColor": `Inbox-iconColor-SzXvr`,
	"displayTable": `Inbox-displayTable-zWY4N`,
	"displayTableRow": `Inbox-displayTableRow-cOHaD`,
	"displayTableCell": `Inbox-displayTableCell-uZNaj`,
	"IconWidth": `Inbox-IconWidth-wEorb`,
	"rightBg": `Inbox-rightBg-s2_qR`,
	"timeWidth": `Inbox-timeWidth-Nvn6f`,
	"addressWidth": `Inbox-addressWidth-AZExJ`,
	"btnWidth": `Inbox-btnWidth-uP4KD`,
	"floatLeft": `Inbox-floatLeft-PdPg4`,
	"inboxBg": `Inbox-inboxBg-fxxGP`,
	"xsHidden": `Inbox-xsHidden-iyI6J`,
	"displayBlock": `Inbox-displayBlock-dCrC6`,
	"tabItem": `Inbox-tabItem-mHxfL`,
	"active": `Inbox-active-aw0At`
};
module.exports = ___CSS_LOADER_EXPORT___;
